import { matchPath } from 'react-router-dom'

// Hàm xử lý liên quan đến URL

// Hàm kiểm tra danh sách url truyền vào có khớp với url hiện tại không
export const checkUrlMatch = (routes = [], currentUrl) => {
  return routes.find((route) => matchPath(route, currentUrl))
}
